(function () {
    if (window.__productPhotoSwipeBound) return;
    window.__productPhotoSwipeBound = true;

    const PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
    const IMAGE_MEDIA_SELECTOR = '.productView-image .media[data-pswp-src]';

    function getProductSection(node) {
        return node ? node.closest(PRODUCT_SECTION_SELECTOR) : null;
    }

    function isTouchLikeDevice() {
        return window.matchMedia('(pointer: coarse)').matches
            || window.matchMedia('(hover: none)').matches
            || ('ontouchstart' in window);
    }

    function getImageMediaNodes(section) {
        if (!section) return [];

        const seen = new Set();
        const nodes = [];

        section.querySelectorAll(IMAGE_MEDIA_SELECTOR).forEach((mediaNode) => {
            const slide = mediaNode.closest('.productView-image');
            const mediaContainer = mediaNode.closest('.productView-img-container');
            const key = (mediaContainer && mediaContainer.getAttribute('data-media-id'))
                || (slide && slide.getAttribute('data-index'))
                || mediaNode.getAttribute('data-pswp-src');

            if (!key || seen.has(key)) return;

            seen.add(key);
            nodes.push(mediaNode);
        });

        return nodes;
    }

    function buildDataSource(mediaNodes) {
        return mediaNodes.map((mediaNode) => {
            const image = mediaNode.querySelector('img');

            return {
                src: mediaNode.getAttribute('data-pswp-src'),
                width: parseInt(mediaNode.getAttribute('data-pswp-width'), 10) || 0,
                height: parseInt(mediaNode.getAttribute('data-pswp-height'), 10) || 0,
                alt: image ? (image.getAttribute('alt') || '') : '',
                msrc: image ? (image.currentSrc || image.getAttribute('src') || '') : ''
            };
        }).filter((item) => item.src && item.width > 0 && item.height > 0);
    }

    function getCurrentMedia(section, mediaNodes) {
        if (!section) return null;

        let activeMedia = section.querySelector('.productView-nav .slick-current .media[data-pswp-src]');

        if (!activeMedia) {
            activeMedia = section.querySelector('.productView-image.slick-current .media[data-pswp-src]');
        }

        if (!activeMedia) {
            activeMedia = mediaNodes.find((mediaNode) => {
                const slide = mediaNode.closest('.productView-image');
                return slide && slide.offsetParent !== null;
            });
        }

        return activeMedia || mediaNodes[0] || null;
    }

    function updatePhotoSwipeUiPosition(pswp) {
        if (!pswp || !pswp.element || !pswp.currSlide) return;

        const slide = pswp.currSlide;
        const contentElement = slide.content && slide.content.element;
        const targetElement = contentElement || slide.container;

        if (!targetElement || typeof targetElement.getBoundingClientRect !== 'function') return;

        const rect = targetElement.getBoundingClientRect();

        if (!rect.width || !rect.height) return;

        const left = Math.max(12, Math.round(rect.left));
        const right = Math.max(12, Math.round(window.innerWidth - rect.right));
        const top = Math.max(12, Math.round(rect.top));
        const width = Math.max(120, Math.round(window.innerWidth - left - right));
        const height = Math.max(120, Math.round(rect.height));
        const centerY = Math.round(top + (height / 2));

        pswp.element.style.setProperty('--pswp-product-ui-left', left + 'px');
        pswp.element.style.setProperty('--pswp-product-ui-right', right + 'px');
        pswp.element.style.setProperty('--pswp-product-ui-top', top + 'px');
        pswp.element.style.setProperty('--pswp-product-ui-width', width + 'px');
        pswp.element.style.setProperty('--pswp-product-ui-height', height + 'px');
        pswp.element.style.setProperty('--pswp-product-ui-center-y', centerY + 'px');
    }

    function bindOverlayClose(pswp) {
        if (!pswp || !pswp.element || pswp.element.dataset.productOverlayCloseBound === '1') return;

        pswp.element.dataset.productOverlayCloseBound = '1';

        pswp.element.addEventListener('click', function (event) {
            const target = event.target;

            if (!(target instanceof Element)) return;
            if (!pswp.isOpen || pswp.isDestroying) return;

            if (target.closest('.pswp__button, .pswp__counter, .pswp__img')) {
                return;
            }

            pswp.close();
        }, true);
    }

    function openProductPhotoSwipe(section, triggerMedia) {
        if (!section || typeof window.PhotoSwipeLightbox !== 'function' || typeof window.PhotoSwipe !== 'function') {
            return;
        }

        const mediaNodes = getImageMediaNodes(section);
        const dataSource = buildDataSource(mediaNodes);

        if (!dataSource.length) return;

        const activeMedia = triggerMedia || getCurrentMedia(section, mediaNodes);
        let index = mediaNodes.indexOf(activeMedia);
        const touchLikeDevice = isTouchLikeDevice();

        if (index < 0 || index >= dataSource.length) {
            index = 0;
        }

        const lightbox = new window.PhotoSwipeLightbox({
            dataSource: dataSource,
            pswpModule: window.PhotoSwipe,
            mainClass: 'pswp--product-gallery',
            preloadFirstSlide: false,
            loop: dataSource.length > 1,
            pinchToClose: true,
            closeOnVerticalDrag: true,
            bgClickAction: 'close',
            imageClickAction: touchLikeDevice ? false : 'zoom',
            tapAction: touchLikeDevice ? false : 'zoom',
            doubleTapAction: 'zoom',
            showHideAnimationType: 'zoom',
            bgOpacity: 1,
            spacing: 0.08,
            secondaryZoomLevel: touchLikeDevice ? 2.5 : 1,
            maxZoomLevel: 4
        });

        lightbox.on('afterInit', function () {
            const pswp = lightbox.pswp;

            if (!pswp) return;

            bindOverlayClose(pswp);

            const queueUpdate = function () {
                window.requestAnimationFrame(function () {
                    updatePhotoSwipeUiPosition(pswp);
                });
            };

            pswp.on('change', queueUpdate);
            pswp.on('imageSizeChange', queueUpdate);
            pswp.on('zoomPanUpdate', queueUpdate);
            pswp.on('resize', queueUpdate);
            pswp.on('openingAnimationEnd', queueUpdate);
            pswp.on('initialZoomInEnd', queueUpdate);

            queueUpdate();
            window.setTimeout(queueUpdate, 60);
        });

        lightbox.init();
        lightbox.loadAndOpen(index);
    }

    document.addEventListener('click', function (event) {
        const zoomButton = event.target.closest('.productView-iconZoom');

        if (zoomButton) {
            const section = getProductSection(zoomButton);

            if (!section) return;

            event.preventDefault();
            openProductPhotoSwipe(section, getCurrentMedia(section, getImageMediaNodes(section)));
            return;
        }

        const mediaNode = event.target.closest(IMAGE_MEDIA_SELECTOR);

        if (!mediaNode) return;

        const section = getProductSection(mediaNode);

        if (!section) return;

        event.preventDefault();
        openProductPhotoSwipe(section, mediaNode);
    }, true);
})();
